import { render, staticRenderFns } from "./ListExpandable.vue?vue&type=template&id=91310a08&scoped=true"
import script from "./ListExpandable.vue?vue&type=script&lang=js"
export * from "./ListExpandable.vue?vue&type=script&lang=js"
import style0 from "./ListExpandable.vue?vue&type=style&index=0&id=91310a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91310a08",
  null
  
)

export default component.exports